$("body").on("click", ".voucher-preview" ,function () {
    $(".voucher-lightbox").fadeIn();

    $(".voucher-lightbox").find(".content").css({"height": $(".voucher").height(),"width": $(".voucher").width()});
    lightBoxResize();

    /*
    $(".content").on("init", function () {
        $(".content").css({"height": $(".slick-slide").height(),"width": $(".slick-slide").width()});
    });

    $(".content").slick({
        slidesToShow: 1,
        infinite: false,
        prevArrow: "<button type='button' class='slick-prev icon-chevron-left'></button>",
        nextArrow: "<button type='button' class='slick-next icon-chevron-right'></button>"
    });*/
});



$(".close-lightbox, .overlay").click(function () {
    $(".voucher-lightbox").fadeOut();
});

function lightBoxResize() {
    var vHeight = $(window).height(),
        vWidth = $(window).width(),
        lightBox = $('.voucher-lightbox');

    lightBox.css({"height":vHeight,"width":vWidth});

    if($(".voucher-lightbox").css("display") !== "none"){

        $("#voucher-info").find(".content").css({"height": vHeight * 0.95,"width": vWidth * 0.95});

        $("#voucher-info").find(".content").css({"height": $(".voucher").height(),"width": $(".voucher").width()});
    }

}

lightBoxResize();

$(window).on("load resize",function () {
    lightBoxResize();
});

$(".voucher[data-id='0']").addClass("active");

var right =  $("#voucher-info").find(".icon-chevron-right"),
    left = $("#voucher-info").find(".icon-chevron-left");


right.click(function () {
    var currentId = (parseInt($("#voucher-info").find(".active").attr("data-id")));
    var next = currentId + 1;


    if(!$(".voucher:last-of-type").hasClass("active")){
        $(".active").removeClass("active");

        $(".voucher[data-id=" + next +"]").addClass("active")
    }
});

left.click(function () {
    var currentId = parseInt($("#voucher-info").find(".active").attr("data-id")),
        prev = currentId - 1;


    if(!$(".voucher:first-of-type").hasClass("active")){
        $(".active").removeClass("active");

        $(".voucher[data-id=" + prev +"]").addClass("active")
    }
});

$("td:has(.error)").addClass("error");